/* eslint-disable linebreak-style */
/* eslint-disable no-useless-escape */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Fade } from 'react-awesome-reveal';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as emailjs from '@emailjs/browser';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ToastContainer, toast } from 'react-toastify';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-toastify/dist/ReactToastify.css';

import { Form } from 'elements/Form';
import Button from 'elements/Button';

export const DiscussForm = (actions) => {
  const { data, resetForm } = actions;
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Configuration from environment variables
  const GOOGLE_SHEETS_URL = process.env.REACT_APP_GOOGLE_SHEETS_URL;
  const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_h4gtndg';
  const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_a9tvs7a';
  const EMAILJS_USER_ID = process.env.REACT_APP_EMAILJS_USER_ID || 'user_csqIxzN5mKsl1yw4ffJzV';
  
  const submitToGoogleSheets = async (formData) => {
    if (!GOOGLE_SHEETS_URL) {
      console.error('❌ Google Sheets URL not configured');
      return false;
    }
    
    console.log('🚀 Submitting to Google Sheets using GET method...');
    console.log('📡 URL:', GOOGLE_SHEETS_URL);
    console.log('📋 Data:', formData);
    
    try {
      // Create query parameters (like your working Contact form)
      const params = new URLSearchParams({
        name: formData.name || '',
        company: formData.company || '',
        email: formData.email || '',
        phone: formData.phone || '',
        projectIdea: formData.projectIdea || '',
      }).toString();
      
      const fullUrl = `${GOOGLE_SHEETS_URL}?${params}`;
      console.log('📤 Full URL:', fullUrl);
      
      // Use GET method like your working client implementation
      const response = await fetch(fullUrl, {
        method: 'GET',
        mode: 'cors',
      });
      
      console.log('📨 Response status:', response.status);
      console.log('📨 Response ok:', response.ok);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log('📨 Response data:', result);
      
      if (result.result === 'success') {
        console.log('✅ Google Sheets: SUCCESS');
        return true;
      } else {
        console.error('❌ Google Sheets error:', result.message);
        return false;
      }
      
    } catch (error) {
      console.error('❌ Network Error:', error.message);
      return false;
    }
  };

  const submitEmail = async () => {
    const { name, company, email, phone, projectIdea } = data;

    // Validate required fields
    if (!name || !company || !email || !phone || !projectIdea) {
      toast.error('Please fill in all fields.');
      return;
    }

    setIsSubmitting(true);

    const templateParams = {
      from_name: `${name} - ${company} ( ${phone} - ${email} )`,
      to_name: 'Zerlak',
      message: projectIdea,
    };

    console.log('🚀 Starting form submission...');
    
    try {
      // Show loading toast
      const toastId = toast.loading('Submitting your request...');
      // Save to Google Sheets first
      const sheetsSuccess = await submitToGoogleSheets(data);

      // Send email via EmailJS
      try {
        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          templateParams,
          EMAILJS_USER_ID,
        );
        
        console.log('✅ Email sent successfully');
        
        // Show appropriate success message
        if (sheetsSuccess) {
          toast.update(toastId, {
            render: "Thanks! We've received your details and will contact you shortly.",
            type: 'success',
            isLoading: false,
            autoClose: 4000,
          });
        } else {
          toast.update(toastId, {
            render: "Email sent. We couldn't save to Sheets, but we'll still reach out.",
            type: 'warning',
            isLoading: false,
            autoClose: 5000,
          });
        }
        
        resetForm();
        
      } catch (emailError) {
        console.error('❌ Email error:', emailError);
        
        if (sheetsSuccess) {
          toast.update(toastId, {
            render: 'Saved to Sheets, but email failed. Please try again later.',
            type: 'error',
            isLoading: false,
            autoClose: 5000,
          });
        } else {
          toast.update(toastId, {
            render: 'Submission failed. Please try again.',
            type: 'error',
            isLoading: false,
            autoClose: 5000,
          });
        }
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="flex flex-col container mx-auto mt-10 justify-center">

      <Fade direction="down" triggerOnce>
        <h1 className="text-5xl text-theme-blue text-center font-bold">Lets Discuss</h1>
      </Fade>

      <Fade direction="up" triggerOnce>
        <p className="font-light text-lg text-gray-400 text-center mb-12">
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Please fill out the form below to discuss your project and we'll get back to you in less than 24 hours.
        </p>
      </Fade>

      <Fade direction="up" triggerOnce>
        <div className="flex flex-col">
          <div className="flex flex-col sm:flex-row mx-auto">
            <Form
              id="name"
              name="name"
              type="text"
              value={data.name}
              placeholder="Your name"
              className=""
              onChange={actions.onChange}
            />
            <Form
              id="company"
              name="company"
              type="text"
              value={data.company}
              placeholder="Your company"
              className=""
              onChange={actions.onChange}
            />
          </div>

          <div className="flex flex-col sm:flex-row mx-auto">
            <Form
              id="email"
              name="email"
              type="email"
              value={data.email}
              placeholder="Your email address"
              className=""
              onChange={actions.onChange}
            />
            <Form
              id="phone"
              name="phone"
              type="number"
              value={data.phone}
              placeholder="Your contact number"
              className=""
              onChange={actions.onChange}
            />
          </div>

          <div className="mx-auto">
            <Form
              id="projectIdea"
              name="projectIdea"
              type="textarea"
              value={data.projectIdea}
              placeholder="Explain about your project idea"
              className=""
              onChange={actions.onChange}
            />
          </div>
          <Button
            className={`text-xl mx-auto px-12 py-3 mt-5 rounded-full border-2 transition duration-200 focus:outline-none ${isSubmitting ? 'bg-theme-purple text-white border-theme-purple opacity-60 cursor-not-allowed' : 'bg-theme-purple text-white border-theme-purple hover:bg-dark-theme-purple'}`}
            type="button"
            onClick={submitEmail}
            disabled={isSubmitting}
            aria-busy={isSubmitting}
            aria-live="polite"
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </Button>
        </div>
      </Fade>

      <ToastContainer />

    </section>
  );
};
